import { render, staticRenderFns } from "./diagnostic_center_list.vue?vue&type=template&id=3540de80&scoped=true"
import script from "./diagnostic_center_list.vue?vue&type=script&lang=js"
export * from "./diagnostic_center_list.vue?vue&type=script&lang=js"
import style0 from "./diagnostic_center_list.vue?vue&type=style&index=0&id=3540de80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3540de80",
  null
  
)

export default component.exports